import i18n from 'i18next'

const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

export function toPersianDigits(str: string): string {
  return str.replace(/\d/g, (d) => persianDigits[parseInt(d, 10)])
}

/**
 * Convert Latin digits to Persian digits when language is Farsi.
 * Use this for any number displayed outside of i18next `t()` calls.
 */
export function localizeDigits(value: string | number): string {
  const str = String(value)
  if (i18n.language === 'fa') {
    return toPersianDigits(str)
  }
  return str
}
